// latest: zhangmyh 2017-8-14 10:22 AM
import { find } from 'lodash'
import { Get, URLs } from 'common'
import uMessage from 'components/message'
import './index.less'
/* global $ ko u */

/* eslint-disable */
let _config
/* eslint-enable */
function init (refer) {
  let selected = null
  const getChild = async function (id, type) {
    let childtype = type + 1
    let data = await Get(URLs.mc_getclass.url, {
      pid: id,
      entid: window.global.user.PURCHASEID
    })
    if (data.length > 0) {
      vm['list' + childtype](data.map(function (o) {
        o.selected = ko.observable(false)
        return o
      }))
    } else {
      vm['list' + childtype]([{
        id: -1,
        name: '(无)',
        selected: false
      }])
    }
    for (let i = type + 2; i < 4; i++) {
      vm['list' + i]([])
    }
  }

  let vm = {
    list0: ko.observableArray([]),
    list1: ko.observableArray([]),
    list2: ko.observableArray([]),
    list3: ko.observableArray([]),
    select: function (id, type) {
      if (id === -1) {
        return
      }
      let list, tmp
      if (selected) {
        if (selected.id == id && selected.type == type) {
          return
        }
        list = this['list' + selected.type]()
        tmp = find(list, ['id', selected.id])
        tmp.selected(false)
        if (selected.type != type) {
          this['list' + selected.type](list)
        }
      }
      if (type < 3) {
        getChild(id, type)
      }
      if (!selected || selected.type != type) {
        list = this['list' + type]()
      }
      tmp = find(list, ['id', id])
      tmp.selected(true)
      selected = {
        type,
        id,
        item: tmp
      }
      this['list' + type](list)
    }
  }
  getChild(0, -1)
  let app = u.createApp()
  app.init(vm, $('#materialclass_refer')[0])
  refer.registerSubmitFunc(() => {
    if (!selected) {
      uMessage('warning', '请选择分类')
    }
    return selected.item
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    repeatable: true
  }, config)
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/materialClass/single/index.js